import { call, put, select, takeEvery } from 'redux-saga/effects'

import type { AppAction, AppState } from '@app/state'

import * as Requests from './rest'
import * as Clinic from './state'

import type { AxiosResponse } from 'axios'

function* handleCreateIntegration() {
  yield takeEvery(Clinic.ActionType.CreateIntegration, createIntegration)
}

function* createIntegration(action: AppAction) {
  if (action.type === Clinic.ActionType.CreateIntegration) {
    const appState: AppState = yield select((a) => a)
    const request = Requests.uploadConfiguration(action.i)
    const response: AxiosResponse<Requests.CreateIntegrationResponse> = yield call(
      request,
      appState.config.apiLocation,
      appState.auth.token,
    )
    if (response.status === 200) {
      yield put(Clinic.actions.createIntegrationSuccess(response.data.id))
    } else {
      yield put(
        Clinic.actions.createIntegrationFailure('unable to create integration'),
      )
    }
  }
}

function* handleListIntegrations() {
  yield takeEvery(Clinic.ActionType.ListIntegrations, listIntegrations)
}

function* listIntegrations(action: AppAction) {
  if (action.type === Clinic.ActionType.ListIntegrations) {
    const appState: AppState = yield select((a) => a)
    const request = Requests.fetchIntegrations()
    const response: AxiosResponse<Requests.ListIntegrationsResponse> = yield call(
      request,
      appState.config.apiLocation,
      appState.auth.token,
    )
    if (response.status === 200) {
      yield put(
        Clinic.actions.listIntegrationsSuccess(response.data.integrations),
      )
    } else {
      yield put(
        Clinic.actions.listIntegrationsFailure(
          'unable to retrieve integrations',
        ),
      )
    }
  }
}

export const sagas = {
  handleCreateIntegration,
  handleListIntegrations,
}
